<template>
  <div class="guildhistory-wrapper">
    <div v-if="!guildhistory || !guildhistory.data" class="text-center py-5">
      <b-spinner label="Loading..." variant="primary"></b-spinner>
      <p class="text-muted mt-2">Loading guild history...</p>
    </div>
    
    <div v-else class="animated fadeIn">
      <!-- Guild History Grid -->
      <div class="rounded shadow-sm border" style="min-height: 500px;">
        <GuildRecords 
          :records="guildhistory.data.data" 
          :server="guildhistory.data.server"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import GuildRecords from './GuildRecords'
  import { mapGetters } from 'vuex'

  export default {
    name: 'GuildHistory',
    components: {
      GuildRecords
    },
    props: {
      username: { type: String, required: true },
      server: { type: String, required: true }
    },
    computed: mapGetters({
      guildhistory: 'guildhistory'
    }),
    watch: {
      username: 'fetchData',
      server: 'fetchData'
    },
    created () {
      this.fetchData()
    },
    methods: {
      fetchData() {
        if (this.username && this.server) {
          this.emit('getGuildHistory', {
            username: this.username, 
            server: this.server
          })
        }
      }
    }
  }
</script>
